import { SessionApiModel, SessionsApiModel } from "../../api-models";

export enum SessionIds {
  MappingYourStrengths = "MappingYourStrengths",
  SoloReport = "SoloReport",
  ViewpointsInvite = "ViewpointsInvite",
  ViewpointsReport = "ViewpointsReport",
  Engage = "Engage",
  Develop = "Develop",
}

export interface SessionsViewModel {
  initialSelectedSessionIndex: number;
  lastAvailableSessionIndex: number;
  sessions: SessionApiModel[];
}

function getInitialSelectedSessionIndex(sessions: SessionApiModel[]) {
  for (let i = 0; i < sessions.length; i++) {
    if (sessions[i].isCompleted === false) {
      return i || 0;
    }

    if (sessions[i].isAvailable === false) {
      return (i || 1) - 1;
    }

    if (i === sessions.length - 1) {
      return i;
    }
  }

  throw new Error("This should be impossible");
}

export function createSessionsViewModelFromApiModel(model: SessionsApiModel): SessionsViewModel {
  const lastAvailableSession = model.sessions
    .slice()
    .reverse()
    .find((s) => s.isAvailable);
  const lastAvailableSessionIndex = lastAvailableSession
    ? model.sessions.indexOf(lastAvailableSession)
    : 0;

  const viewModel = {
    sessions: model.sessions,
    lastAvailableSessionIndex,
    initialSelectedSessionIndex: getInitialSelectedSessionIndex(model.sessions),
  } as SessionsViewModel;

  return viewModel;
}
